<template>
  <o-alert v-if="reservation" :title="$t('components.reservation.create.move.title')" show variant="info" class="m-6">
    <p v-if="reservation.infoLabel" class="text-sm">
      {{ reservation.infoLabel }}
    </p>

    <p v-else-if="reservation.customer && reservation.reservation" class="text-sm">
      {{ reservation.customer.displayName }} - {{ reservation.reservation.infoLabel }}
    </p>
  </o-alert>
</template>

<script setup lang="ts">
import {
  OAlert,
} from '@/components/elements'

interface Props {
  reservation?: object | null
}

withDefaults(defineProps<Props>(), {
  reservation: null,
})
</script>
